// Angular + Plugins
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { DialogModule } from "@bfx/primeng/dialog";
import { ButtonModule } from "@bfx/primeng/button";
import { InputTextareaModule } from "@bfx/primeng/inputtextarea";

// components
import { BfxTradeBlotterComponent } from "./bfx-trade-blotter.component";
import { BfxTradeContextMenuComponent } from "./bfx-trade-contextmenu.component";
// services
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxTradeBlotterService } from "./services/bfx-trade-blotter.service";
import { BfxTradeActionsService } from "./services/bfx-trade-actions.service";
import { BfxTradeContextMenuService } from "./services/bfx-trade-contextmenu.service";
// Modules
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxVwapModule } from "../bfx-vwap/bfx-vwap.module";

import { BfxBlotterTradeFilterService } from "../bfx-blotter-trade/services/bfx-blotter-trade-filter.service";
import { BfxTradeBlotterDetailsComponent } from "./bfx-trade-blotter-details.component";
import { BfxMenusModule } from "app/bfx-menus/bfx-menus.module";
import { DealOrderTypeRenderer } from "./renderers/DealOrderTypeRenderer";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { BfxTradeDetailsContextMenuService } from "./services/bfx-trade-blotter-details-contextmenu.service";
import { BfxRiskTradeBlotterDetailsComponent } from "./bfx-risk-trade-blotter-details.component";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BfxInterfaceControlsModule } from "app/bfx-interface-controls/bfx-interface-controls.module";
import { CommonIntentRenderer } from "app/bfx-blotter-orders/renderers/CommonIntentRenderer";

@NgModule({
  declarations: [
    BfxTradeBlotterComponent,
    BfxTradeBlotterDetailsComponent,
    BfxRiskTradeBlotterDetailsComponent,
    BfxTradeContextMenuComponent,
    DealOrderTypeRenderer,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    AutoCompleteModule,
    CheckboxModule,
    OverlayPanelModule,
    DialogModule,
    ButtonModule,
    InputTextareaModule,
    AgGridModule.withComponents([CommonIntentRenderer]),
    BfxSharedModule,
    BfxBlotterFilterModule,
    BfxMenusModule,
    BaseComponentsModule,
    BfxVwapModule,
    BfxElementsLibraryModule,
    BfxInterfaceControlsModule,
  ],
  exports: [
    BfxTradeBlotterDetailsComponent,
    BfxRiskTradeBlotterDetailsComponent,
    BfxTradeBlotterComponent,
    BfxTradeContextMenuComponent,
    DealOrderTypeRenderer,
  ],
  providers: [
    BfxTradeBlotterService,
    BfxTradeActionsService,
    BfxTradeContextMenuService,
    BfxTradeDetailsContextMenuService,
    BfxBaseBlotterColumnSelectorService,
    BfxBlotterTradeFilterService,
  ],
  bootstrap: [
    BfxTradeBlotterComponent,
    BfxTradeBlotterDetailsComponent,
    BfxRiskTradeBlotterDetailsComponent,
  ],
})
export class BfxTradeBlotterModule {}
